<template>
  <z-page class="agent-manage">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>姓名：</div>
        <div>
          <el-input
            size="mini"
            class="long"
            v-model="search.text"
            placeholder="关键字搜索"
            suffix-icon="el-icon-search"
          ></el-input>
        </div>
      </div>
      <div @click="getdata(1)" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
    </div>

    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>姓名</div>
        <div>QQ</div>
        <div>联系电话</div>
        <div>账号</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div style="text-align: center" class="list-item" v-if="data_list.length<=0">暂无数据</div>
        <div v-for="(item, index) in data_list" :key="index" class="list-item">
          <div>{{item.agentName}}</div>
          <div>{{ item.qq||'--' }}</div>
          <div>{{ item.mobile ||'--'}}</div>
          <div>{{ item.account}}</div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <z-pagination
      @sizeChange="getdata()"
      @pageChange="handleCurrentChange"
      :current-page.sync="nowPage"
      :page-size="10"
      :total="total"
    ></z-pagination>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      data_list: [],
      total: 0,
      nowPage: 1,
      search:{},
      loading:false
    };
  },
  created(){
    this.getdata(1)
  },
  methods: {
      clearsearch(){
        this.search.text=''
        this.getdata(1)
      },
    // 页面改变
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getdata();
    },
    //获取数据方法
    getdata(num) {
      this.nowPage=num||this.nowPage
      this.loading = true;
      let url = `/api/supplier/get/agent/list`;
      this.$http
        .post(url, {
            agentName:this.search.text,
            page: num || this.nowPage, // 页码
          
        })
        .then(res => {
          if (res.code == "200") {
            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
  }
};
</script>

<style lang="less" scoped>
.agent-manage {
    .list-head,
  .list-item {
    > div {
      width: 25%;
      &:nth-child(3) {
        width: 25%;
      }
    }
  }
}
</style>